import React from 'react';
import PropTypes from 'prop-types';

import Layout from '@c/layout/Layout';
import { Tip, Tips } from '@c/tips';
import FieldGroup from './FieldGroup';
import StateSelector from '@c/StateSelector';
import BoundNameField from '@c/BoundNameField';
import BoundTextField from '@c/BoundTextField';
import { ProgressSections } from '@c/progress';
import { AppLocation } from 'utils/enums';
import { MaritalStatus } from '!m/client-data/enums';
import { validatePersonNameUniqueness } from '!m/utils';
import { getStateAbbreviation } from 'utils';
import Typography from '@wui/basics/typography';
import withHandleNameConflicts from 'hocs/withHandleNameConflicts';

import MaritalStatusTip from './MaritalStatusTip';

class PersonalDetails extends React.Component {
  static contextTypes = {
    testator: PropTypes.object,
    clientDataHolder: PropTypes.object,
  };

  static propTypes = {
    handleNameConflicts: PropTypes.func.isRequired,
  };

  componentDidMount() {
    // when passed certain parameters, update clientData so that input elements will use them as default values
    const prefillParams = {
      state: [this.context.testator.address, 'state', getStateAbbreviation],
      relationship: [this.context.testator, 'maritalStatus', v => MaritalStatus.normalize(v)],
    };
    const params = new URLSearchParams(window.location.search);
    Object.entries(prefillParams).forEach(([name, [object, parameter, normalize]]) => {
      if (params.get(name)) {
        object.setRawValue(parameter, normalize(params.get(name)));
      }
    });

    this.context.clientDataHolder.analyticsEvents.dataLayer.push({
      event: 'willing.page.loaded.personal-details',
    });
  }

  nameValidations() {
    return [
      validatePersonNameUniqueness(this.context.clientDataHolder.clientData, this.context.testator),
    ];
  }

  get firstTime() {
    return !this.context.testator.name;
  }

  renderFirstTimeTip() {
    if (!this.firstTime) {
      return null;
    }

    return (
      <Tip title="Welcome to Your Estate Plan!">
        You have officially started your plan. All of your information is secure and confidential.
        This won't take long, and you'll be very glad you did it.
      </Tip>
    );
  }

  renderContent() {
    const { handleNameConflicts } = this.props;

    return (
      <FieldGroup level={1} title="About You">
        <Typography variant="caption">
          Enter your first and last name as it appears on your government-issued ID.
        </Typography>
        <BoundNameField
          label="Full Name"
          onBlur={handleNameConflicts(this.context.testator)}
          additionalValidations={this.nameValidations()}
        />
        <StateSelector
          dataPathOverride="address.state"
          addressObject={this.context.testator.address}
        />
        <BoundTextField path="maritalStatus" label="Marital Status" />
      </FieldGroup>
    );
  }

  render() {
    return (
      <Layout
        progressPage={ProgressSections.ABOUT_YOU.BASIC_INFO}
        appLocation={AppLocation.ABOUT_YOU}
      >
        <Tips>
          {this.renderFirstTimeTip()}
          <Tip title="State">
            All documents are based on current state laws.
            <br />
            <br />
            Enter the state of your primary residence. If you own property in different states,
            we'll address that later on.
          </Tip>

          <MaritalStatusTip />
        </Tips>

        {this.renderContent()}
      </Layout>
    );
  }
}

export default withHandleNameConflicts(PersonalDetails);
